<template>
  <v-app
    id="appContent"
    v-bind:class="{
      'hide-controls': hideControls,
      'quiz-in-progress': isQuizInProgress
    }"
  >
    <TopNavi v-if="this.$router.currentRoute.name !== 'quiz'" />
    <v-main>
      <router-view />
    </v-main>
    <QuizBottomNavi v-if="this.$router.currentRoute.name === 'quiz'" />
    <CommonFooter v-else />
  </v-app>
</template>

<script>
import TopNavi from "@/components/TopNavi.vue";
import CommonFooter from "@/components/CommonFooter.vue";
import QuizBottomNavi from "@/components/QuizBottomNavi.vue";
import { QUIZ_PAGE_NAME } from "@/config.js";

export default {
  name: "App",
  components: {
    TopNavi,
    CommonFooter,
    QuizBottomNavi
  },
  data() {
    return {
      hideControls: false
    };
  },
  computed: {
    isQuizInProgress() {
      let quizState = this.$store.state.quizState;
      return ["ask", "check"].includes(quizState);
    }
  },
  methods: {
    hideControlsAfterInterval() {
      this.hideControls = false;
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.hideControls = true;
      }, 3000);
    }
  },
  created() {
    document.title = QUIZ_PAGE_NAME;
  },
  mounted() {
    this.timer = null;
    window.addEventListener("mousemove", this.hideControlsAfterInterval);
    this.hideControlsAfterInterval();
  }
};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease-in-out;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

#appContent.hide-controls.quiz-in-progress * {
  cursor: none !important;
}
</style>
